<nb-card>
  <nb-card-header>
    Lịch sử gần đây

    <button
      *ngIf="isAuthenticated && mode == 'customer' && customer"
      nbButton
      outline
      shape="semi-round"
      status="primary"
      size="small"
      class="cancel"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      (click)="onNew()"
    >
      <nb-icon icon="activity-outline"></nb-icon>
      Tạo trạng thái
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div *ngFor="let item of display; let i = index" class="col-md-12">
        <ngx-view-history
          [history]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
        ></ngx-view-history>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer *ngIf="!done && mode == 'customer'">
    <nb-actions size="small" class="see-more-button">
      <nb-action (click)="getMore()">
        <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
